<div fxFlex="80" fxFlexOffset="10">
  <div class="toto">
    <h2 class="title-CVM">Display table</h2>
    @for (table of TablesVisualization; track table.id) {
    <div>
      <mic-app-table-visualization [func]="table"></mic-app-table-visualization>
    </div>
    }
  </div>
</div>
